// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"ed9d11b5","601":"4a24fde1","689":"4a24fde1","773":"4a24fde1","961":"4a24fde1","981":"4a24fde1"}[chunkId] + ".css";
};